const dayjs = require('dayjs');

/**
 * Checks the validity of an account's trial and subscription periods.
 * NOTE - This is a front end check to summarize the accounts status for the client app. It should NOT be used to grant authorization to server side resources in any way
 *
 * @param {Object} account - The account object with trial and subscription date information.
 * @param {string} account.trialTimeStartOn - The start date of the trial period.
 * @param {string} account.trialTimeEndOn - The end date of the trial period.
 * @param {string} account.subscriptionTimeStartOn - The start date of the subscription period.
 * @param {string} account.subscriptionTimeEndOn - The end date of the subscription period.
 * @returns {Object} An object containing the validity status of the trial and subscription, and the account plan.
 */
function checkAccountValidity(account) {

    //if no account is passed, return null
    if (!account) return null;

  const now = dayjs();
  const isPendingToDelete = account.trashDate;
  const isTrialValid = !account.trashDate && (
    (account.trialTimeStartOn && !account.trialTimeEndOn && now.isAfter(dayjs(account.trialTimeStartOn))) ||
    (account.trialTimeStartOn && account.trialTimeEndOn && now.isAfter(dayjs(account.trialTimeStartOn)) && now.isBefore(dayjs(account.trialTimeEndOn)))
  );
  const isSubscriptionValid = !account.trashDate && account.subscriptionTimeStartOn && account.subscriptionTimeEndOn && now.isBefore(dayjs(account.subscriptionTimeEndOn)) && now.isAfter(dayjs(account.subscriptionTimeStartOn));

  let plan = 'none';
  if (isSubscriptionValid) {
    plan = 'paid';
  } else if (isTrialValid) {
    plan = 'trial';
  }

  return { isPendingToDelete, isTrialValid, isSubscriptionValid, plan };
}

module.exports = checkAccountValidity;